module.exports = __webpack_public_path__ + "static/media/background1_large.a3aacb25.svg";